import { isFulfilled } from '@reduxjs/toolkit';

import { userActions } from '@modules';
import { TMiddleware, VerifyNextEnum } from '@modules/types';

export const setCountry: TMiddleware = store => next => action => {
  const nextFromApi = action.payload?.data?.next;

  if (isFulfilled(action) && nextFromApi === VerifyNextEnum.setCountry) {
    store.dispatch(userActions.setIsCountry(true));
    store.dispatch(userActions.setIsIntroModal(true));
  }

  return next(action);
};

export default setCountry;
